<template>
  <div> 
  <HelpSubcategoryPage v-if="subcategories.includes(route.params.slug)"></HelpSubcategoryPage>
  <HelpConditionPage v-else param_name="slug"></HelpConditionPage>
</div>
</template>

<script setup>
import { useGlobalStore } from "~/stores/global";

const globalStore = useGlobalStore();
const route = useRoute();

const subcategories = globalStore.siteSettings.help_and_advice.subcategories;
</script>